import axios from "axios";
import Vue from "vue";
import { i18n } from "Libs/core/plugins";

const EventHub = new Vue();

axios.defaults.headers.common["ProfileId"] = window.USER_INFO ? window.USER_INFO.currentProfileId : "";

const Interceptor = axios.interceptors.response.use(
  function(response) {
    // console.log("interceptor success:", response);
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function(error) {
    // console.log("interceptor error:", error.response);
    switch (error.response.status) {
      case 401:
        EventHub.$emit("snackbar", {
          bottom: true,
          msg: i18n.t("errors.sessionExpired"),
          type: "error",
        });
        setTimeout(function() {
          window.location.reload;
        }, 4000);
        break;
      case 405:
        EventHub.$emit("snackbar", {
          bottom: true,
          msg: i18n.t("errors.genericError"),
          type: "error",
        });
        break;
      case 400:
        break;
      default:
        EventHub.$emit("snackbar", {
          bottom: true,
          msg: i18n.t("errors.serverError"),
          type: "error",
        });
        break;
    }
    // window.location.href = 'https://localhost/PassDelivery.Web'
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);

export { EventHub, Interceptor };
